import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import cssVars from 'css-vars-ponyfill';
import { Provider } from 'react-redux';
import { ConnectedRouter as Router } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import 'font-awesome/css/font-awesome.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { createDynatraceAdapter } from '@sm-npm/analytics-dynatrace';
import { createMatomoAdapter } from '@sm-npm/analytics-matomo';
import { AnalyticsProvider } from '@sm-npm/analytics-react';
import { createAnalytics } from '@sm-npm/analytics-core';
import * as serviceWorker from './serviceWorker';
import { handleAppInit } from './store/actions/appActions';
import configureStore from './store/configureStore';
import App from './App';
import './index.scss';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

store.dispatch(handleAppInit());

const matomoAdapter = createMatomoAdapter({
  siteId: 26,
  trackerBaseUrl: 'https://matomo.selectmedical.com',
});

const dynaTraceAdapter = createDynatraceAdapter({});

const client = createAnalytics({
  adapters: [matomoAdapter, dynaTraceAdapter],
  autoTracking: {
    enabled: true,
    trackInitialPage: true,
    waitForIdentify: false,
  },
});

cssVars({
  onlyLegacy: false,
});

const root = ReactDOMClient.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <Router history={history}>
      <AnalyticsProvider analytics={client}>
        <App />
      </AnalyticsProvider>
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
